export default __webpack_public_path__ + "static/media/star.278d615d.svg";